var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"XR-top"},[_c('div',[_c('div',{staticClass:"XR-top-bg",style:({  backgroundImage:'url('+_vm.siteConfig.MobileBgImage+')' })},[_c('div',{staticClass:"headimgDiv"},[_c('img',{staticClass:"headpic",attrs:{"src":_vm.url}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c3f170","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/usercenter/top/top.vue
// module id = null
// module chunks = 